export enum PAGE_STATUS {
    LOADING = 'LOADING',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    NO_PROJECTS = 'NO_PROJECTS',
    NO_SELECTED_PROJECT = 'NO_SELECTED_PROJECT',
}

